import React from 'react';
import { RegularButtonSize } from 'fronton-react';
import { RegularButton as Button } from 'fronton-react/button/regular-button/regular-button';

export const SurfaceFooter = (props: { size: RegularButtonSize; wide?: boolean }) => (
  <Button
    size={props.size}
    variant="primary"
    label="Далее"
    type="submit"
    form="surface-form"
    {...(props.wide ? { wide: props.wide } : {})}>
    Далее
  </Button>
);
